import { render, staticRenderFns } from "./TradingTerms.vue?vue&type=template&id=333edd48&scoped=true"
import script from "./TradingTerms.vue?vue&type=script&lang=js"
export * from "./TradingTerms.vue?vue&type=script&lang=js"
import style0 from "./TradingTerms.vue?vue&type=style&index=0&id=333edd48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333edd48",
  null
  
)

export default component.exports